/**
 * Expandable order-auth table wired to CustomTable.
 *
 * Parent rows use {@link CustomTable}; expanded J-code details render via
 * {@link ExpandableRowContentForOrderAuth} and oasis-ui-kit {@link DataGrid}.
 */
import CustomTable from "../custom-table/custom-table";
import NoData from "../noData/noData";
import ExpandableRowContentForOrderAuth from "./expandableRowContentForOrderAuth";
import ExpnadableBusniessOfficeNotesForSiblings from "./expnadableBusniessOfficeNotesForSiblings";
// import { clubbedDummyData } from "./clubbedDummyData";
import { useExpandableOrderAuthTable } from "./hooks/useExpandableOrderAuthTable";
import {
  ExpandableTableForOrderAuthHeaders,
  EXPANDABLE_ORDER_AUTH_TABLE_NAME,
} from "./singleTableRow";
import {
  ExpandableTableForOrderAuthProps,
  ExpandableTableForOrderAuthTableRow,
} from "./types";

/**
 * Renders the expandable order-auth table.
 *
 * Checkboxes support multi-select; only the last checked row auto-expands.
 *
 * @param props - Table data, expanded-row content type, loading, and error state
 * @returns Expandable custom-table view for order auth rows
 */
const ExpandableTableForOrderAuth = ({
  data,
  expandedContentType,
  isLoading,
  error,
  onSelectedOrderIdsChange,
}: ExpandableTableForOrderAuthProps) => {
  const { tableData, handleRowExpansionChange, toggleCheckboxSelection } =
    useExpandableOrderAuthTable(data, onSelectedOrderIdsChange);

  if (error) {
    return <NoData text={error} />;
  }

  return (
    <CustomTable
      tableHeaders={ExpandableTableForOrderAuthHeaders}
      tableData={tableData}
      tableName={EXPANDABLE_ORDER_AUTH_TABLE_NAME}
      itemsPerPage={10}
      pagesPerView={4}
      count={tableData.length}
      totalCount={tableData.length}
      isFetching={isLoading}
      hideSearchBar
      isExpandableRowTable
      expandableRowContent={(rowData: ExpandableTableForOrderAuthTableRow) => (
        <>
          {expandedContentType === "table" ? (
            <ExpandableRowContentForOrderAuth
              authOnFileData={rowData.authOnFileData}
            />
          ) : (
            <ExpnadableBusniessOfficeNotesForSiblings
              notes={rowData.authOnFileData.reports ?? []}
            />
          )}
        </>
      )}
      onRowExpansionChangeFromTableBody={handleRowExpansionChange}
      toggleCheckboxSelection={toggleCheckboxSelection}
      hidePagination
    />
  );
};

export default ExpandableTableForOrderAuth;
